module.exports = __webpack_public_path__ + "img/d42e3f7889494be8b583d0d81b4f5a92.59e10079.jpg";